<template>
  <div id="app">
    <TopBar />
    <router-view />
    <div
      class="developed-container"
      v-if="$route.meta.showLogo"
      :class="{ 'login-layout': $route.path === '/login' }"
    >
      <span class="developed-label">Sviluppato da</span>
      <img
        src="@/assets/libero_tratto_logo.png"
        alt="Liberotratto — logo"
        class="lt-logo"
      />
    </div>
  </div>
</template>

<script>
import TopBar from "@/components/TopBar.vue"; // Percorso del componente TopBar
// import { ref, watch } from "vue";
// import { useRoute } from "vue-router";

export default {
  name: "App",
  components: {
    TopBar,
  },
  // setup() {
  //   const route = useRoute();
  //   const breadcrumbs = ref([]);

  //   const generateBreadcrumbs = (currentRoute) => {
  //     return currentRoute.matched.map((matchedRoute) => ({
  //       name: matchedRoute.meta.breadcrumb || matchedRoute.name, // Usa il breadcrumb dal meta o il nome della rotta
  //       path: matchedRoute.path,
  //     }));
  //   };

  //   // Inizializza i breadcrumbs
  //   breadcrumbs.value = generateBreadcrumbs(route);

  //   // Osserva i cambiamenti della route e aggiorna i breadcrumbs
  //   watch(
  //     () => route.path,
  //     () => {
  //       breadcrumbs.value = generateBreadcrumbs(route);
  //     }
  //   );

  //   return { breadcrumbs };
  // },
};
</script>

<style src="@/css/App.css"></style>
